
<template>
    <div>
        <h3>Sign Up to the Deepest Why!</h3>
        <input class="input-text" type="text" placeholder="email address" id="emailSignUp" :ref="'emailSignUp'"  @blur="formValidation"/>
        <div id="emailValidate" :ref="'emailValidate'"></div>
        <div :ref="'emailLoader'" class='emailLoader'>Checking<span class='loader__dot'>.</span><span class='loader__dot'>.</span><span class='loader__dot'>.</span></div>
        <input type="checkbox" id="emailAsUserName" :ref="'emailAsUserName'" @blur="formValidation"/>
            <small> Email as Username</small>
        <div :ref="'showForUserName'">
            <input class="input-text" type="text" placeholder="username" id="username" :ref="'username'" @blur="formValidation"/>
        </div>
        <div :ref="'usernameValidate'"></div>
        <small>Select the country you live in: </small>
        <br>
        <select v-model="selectedCountry" @blur="formValidation" id="country" :ref="'country'">
            <option v-for="(country, index) in countries" :key="index+'country'" :value="country.value">{{country.text}}</option>
        </select>
        <br>
        <div v-if="phoneCountry === 'US'">
            <input class="input-text" type="phone" placeholder="phone number" id="phone" :ref="'phone'" @blur="formValidation"/>
            <div :ref="'phoneValidate'"></div>
        <div :ref="'phoneLoader'" class='phoneLoader'>Checking<span class='loader__dot'>.</span><span class='loader__dot'>.</span><span class='loader__dot'>.</span></div>

            <input type="checkbox" id="phoneVerify" :disabled="phoneEnabled" :ref="'phoneVerify'" @blur="formValidation"/>
            <small>Verify your phone?</small>
        <div :ref="'shortCodeLoader'" class='shortCodeLoader'>Sending Short Code<span class='loader__dot'>.</span><span class='loader__dot'>.</span><span class='loader__dot'>.</span></div>

        </div>
        <br>
        <div v-if="verifyPhone">
            <div id="waitingShortCode" v-if="verifyShortCode === false"><small>Check your phone for a verification code</small>
                <br>
                <input class="input-text" type="text" id="phoneShortCode" :ref="'phoneShortCode'" placeholder="DW-" @blur="formValidation" />
                <br>
                <button @click.prevent="submitSC">Submit</button>
                <button @click.prevent="clearSC">Clear</button>
            </div>
            <div v-else>Green Check Mark<small> Your phone is verified!</small></div>
            <div :ref="'shortCodeValidate'"></div>
        </div>
        Enter a Super Secret Password
        <br>
        <input class="input-text" type="password" id="password" :ref="'password'" @blur="formValidation" @keydown="testEntry" />
        <div :ref="'credRequirements'"><span :ref="'lc'"><small>a-z,</small></span><span :ref="'uc'"><small> A-Z,</small></span><span :ref="'num'"><small> 0-9,</small></span><span :ref="'sym'"><small> Symbols,</small></span><span :ref="'len'"><small> Min. Length: 8</small></span>
        </div>
        <input class="input-text" type="password" id="password2" :ref="'password2'" @blur="formValidation"/>
        <div :ref="'credValidate'"></div>
        <input type="checkbox" id="privy" :ref="'privy'" @blur="formValidation"/>
        <small>You've read our privacy policy</small>
        <br>
        <button :ref="'submitBtn'" :disabled="okToSubmit" @click.prevent="submit">Submit</button>
        <button @click.prevent="clear">Clear</button>
        <div :ref="'submitLoader'" class='submitLoader'>Submitting<span class='loader__dot'>.</span><span class='loader__dot'>.</span><span class='loader__dot'>.</span></div>
        <p>
            Membership has it's perks!
            <br>
            Already a member? <a href="#" @click.prevent="showLogin">Login</a>
        </p>

    </div>
</template>

<script>
/* eslint-disable*/
import { AsYouType } from 'libphonenumber-js';
import axios from 'axios';
import { mapGetters, mapActions } from 'vuex';
var HOST = '';
export default {
    name:'signup',
    data() {
        return {
            emailNeedsCorrection: false,
            emailUserName: false,
            usernameNeedsCorrection: false,
            countries: [
                {value:"US", text:"United States"},
                {value:"MEX", text:"Mexico"},
                {value:"CA", text:"Canada"},
                {value:"DE", text:"Germany"}
                ],
            selectedCountry: '',
            phoneNumber: '',
            checkNumber: false,
            PhoneVerified: false,
            cred:[],
            submitReady: false,
            phoneInUse: false,
            tempID: '',
            confirmationID:'',
            email:'',
            emailIsUserName:null,
            UsrName: '',
            verifiedPhone:'unverified',
            phoneStatus: 'pending',
            privacyAcknowledged: false,
            phoneLoader: null,
            emailLoader: null,
            shortCodeLoader: null,
            submitLoader:null
        }
    },
    mounted(){
        HOST = this.getHost;
        // this.$refs['emailValidate'].hidden = true;
        // this.$refs['usernameValidate'].hidden = true;
        // this.$refs['countryValidate'].hidden = true;
        // this.$refs['phoneValidate'].hidden = true;
        // this.$refs['shortCodeValidate'].hidden = true;
        // this.$refs['credRequirements'].hidden = true;
        // this.$refs['credValidate'].hidden = true;
    },
    computed: {
        ...mapGetters(['getVisitorStatus', 'getUserStatus', 'getHost']),
        phoneCountry(){
            return this.selectedCountry;
        },
        verifyPhone(){
            console.log(this.checkNumber);
            if(this.checkNumber){
                return true;
            } else {
                return false;
            }
        },
        verifyShortCode(){
            if(this.PhoneVerified){
                return true;
            } else {
                return false;
            }
        },
        okToSubmit(){
            if(this.submitReady){
                return false;
            } else {
                return true;
            }
        },
        phoneEnabled(){
            if(this.phoneInUse){
                return true;
            } else {
                return false;
            }
        },
        phoneLoaderActive(){
            if(this.phoneLoader){
                return true;
            } else {
                return false;
            }
        },
        emailLoaderActive(){
            if(this.emailLoader){
                return true;
            } else {
                return false;
            }
        },
        shortCodeLoaderActive(){
            if(this.shortCodeLoader){
                return true;
            } else {
                return false;
            }
        },
        submitLoaderActive(){
            if(this.submitLoader){
                return true;
            } else {
                return false;
            }
        }

    },
    methods: {
    ...mapActions(['updateUserStatus', 'updateVisitorStatus', 'showSigninForm', 'showLoginForm']),
        showLogin(){
            this.showSigninForm(false);
            this.showLoginForm(true);
        },
        async submit(){
            console.log("submit form");
            //1. build submit object
            let frmUsername = '';
            if(this.emailIsUserName){
                frmUsername = this.email;
            } else {
                frmUsername = this.UsrName;
            }
            let frm = {
                username: frmUsername,
                email: this.email,
                phone: this.phoneNumber,
                country: this.selectedCountry,
                pwd: this.cred,
                phoneVerified: this.verifiedPhone,
                phoneStatus: this.phoneStatus,
                privacy: this.privacyAcknowledged
            }
            this.$refs["submitLoader"].style="visibility:visible; color:green; display:block;"
            let userSignUp = await axios.post(`${HOST}/signup`,{frm});
            console.log(userSignUp.data);
            if (userSignUp.data.message === "user signed up"){
                this.$refs["submitLoader"].innerText = "Check your email"
                let d = new Date();
                let expires = d.setTime(d.getTime() + (1*24*60*60*1000));
                this.$cookies.set("dw_id", "pending", {expires:expires.toString(), httpOnly: true, domain: '.deepestwhy.com'}); //CHANGED TO PENDING

                this.updateUserStatus("notauth");
                this.$cookies.set("authStatus", "notauth", {expires: expires.toString(), httpOnly: true, domain: '.deepestwhy.com'});
                this.updateVisitorStatus("pending");
                this.$nextTick(() => this.getUserStatus);
                this.$nextTick(() => this.getVisitorStatus);
                this.showSigninForm(false);
            }
        },
        clear(){
            console.log("clear form");
            window.location.reload();

        },
        clearSC(){
            this.$refs["phoneShortCode"].value = "";
        },
        async submitSC(event){
            console.log(event.target.id);
            console.log("waiting for verification");
            let validate = {
                server_scode: this.$refs["phoneShortCode"].value,
                message_id: this.tempID
            }
            let testScode = await axios.post(`${HOST}/validDetails`, {validate});

            console.log(testScode.data);
            if(testScode.data === "yay"){
                this.PhoneVerified = true;
                this.$refs["shortCodeValidate"].innerText = "";
                this.verifiedPhone = 'verified';
            } else {
                this.$refs["shortCodeValidate"].style = "color:red";
                this.$refs["shortCodeValidate"].innerText = testScode.data;
            }

        },
        testEntry(event){
            let cred = [];
            cred.push(event.target.value);

            let hasUpperCase = /[A-Z]/.test(cred);
            let hasLowerCase = /[a-z]/.test(cred);
            let hasNumbers = /\d/.test(cred);
            let hasSymbols = /\W/.test(cred);

            if(hasLowerCase){
                this.$refs["lc"].style="color:green";
            } else {
                this.$refs["lc"].style="color:red";
            }
            if(hasUpperCase){
                this.$refs["uc"].style="color:green";
            } else {
                this.$refs["uc"].style="color:red";
            }
            if(hasNumbers){
                this.$refs["num"].style="color:green";
            } else {
                this.$refs["num"].style="color:red";
            }
            if(hasSymbols){
                this.$refs["sym"].style="color:green";
            } else {
                this.$refs["sym"].style="color:red";
            }
            if(event.target.value.length >= 8){
                this.$refs["len"].style="color:green";
                this.$refs["len"].innerText = `Length: ${event.target.value.length}`;
            } else {
                this.$refs["len"].innerText = `Length: ${event.target.value.length}`;
                this.$refs["len"].style="color:red";
            }


        },
        async formValidation(event){
            console.log(event);
            console.log(this.$refs);
            if(event.target.id === "emailSignUp"){
                const expression = /\S+@\S+/
                let test = expression.test(String(event.target.value).toLowerCase());
                console.log("test", test);
                if(!test){
                    this.$refs["emailValidate"].hidden = false;
                    this.$refs["emailValidate"].style = 'color:red';
                    this.$refs["emailValidate"].innerText = "you need a real email address";
                    this.emailNeedsCorrection = true;
                    return this.emailNeedsCorrection;
                } else {
                    this.$refs["emailValidate"].innerText = "";
                    this.emailNeedsCorrection = false;
                    let test = {
                        method: 'email',
                        value: this.$refs["emailSignUp"].value
                    }
                    this.$refs["emailLoader"].style="visibility:visible; display:block;";
                    //test db for email account exists and resolve async
                    let verification = await axios.post(`${HOST}/verifyMethods`, {test});
                    console.log(verification.data);
                    if(verification.data === "email is already in use"){
                        this.$refs["emailValidate"].style = 'color:red';
                        this.$refs["emailValidate"].innerText = "Email Address is already in use";
                        this.$refs["emailLoader"].style="visibility:hidden";
                    } else {
                        this.email = test.value;
                        this.$refs["emailLoader"].innerText = "email account is not signed up"
                        // this.$refs["emailLoader"].style="visibility:hidden";
                    }
                }
            } else
            //////////////////////////////////////
            if(event.target.id === "emailAsUserName"){
                console.log("EMAIL AS USERNAME")
                if(event.target.checked){
                    console.log(event.target.checked);
                    this.emailUserName = false;
                    this.$refs['showForUserName'].hidden = true;
                    this.emailIsUserName = true;
                } else {
                    this.$refs['showForUserName'].hidden = false;
                    // let self = this;
                    this.$nextTick(() => this.$refs['username'].focus());
                    this.emailIsUserName = false;
                }
            } else
            //////////////////////////////////////
            if(event.target.id === "username"){
                if (event.target.value.length <= 5){
                    this.$refs["usernameValidate"].hidden = false;
                    this.$refs["usernameValidate"].style = 'color:red';
                    this.$refs["usernameValidate"].innerText = `the username needs to be longer than: ${event.target.value.length}`;
                    this.usernameNeedsCorrection = true;
                    return this.usernameNeedsCorrection;
                } else {
                    this.$refs["usernameValidate"].innerText = "";
                    this.usernameNeedsCorrection = false;
                    this.UsrName = event.target.value;
                }
            } else
            ////////////////////////////////////////
            if( event.target.id === "country"){
                if(event.target.value === "US"){
                    this.phoneCountry;
                }
            } else
            ////////////////////////////////////////
            if(event.target.id === "phone"){
                if(event.target.value.length > 10){
                    this.$refs["phoneValidate"].style = 'color:red';
                    this.$refs["phoneValidate"].innerText = `please check your phone number`;
                } else {
                    let asyoutype = new AsYouType("US");
                    asyoutype.input(this.$refs["phone"].value);
                    let entered = asyoutype.getNumber().number;
                    console.log(entered);
                    this.$refs["phoneValidate"].innerText = "";
                    this.phoneNumber = entered;
                    this.$refs["phone"].value = entered;
                    let test = {
                        value: entered,
                        method: "phone"
                    }
                    this.$refs["phoneLoader"].style = "visibility:visible; color:green; display:block;";
                    let testPhone = await axios.post(`${HOST}/verifyMethods`, {test});
                    console.log(testPhone.data);
                    if (testPhone.data.message === "phonenumber is already in use"){
                    this.$refs["phoneValidate"].style = 'color:red';
                    this.$refs["phoneValidate"].innerText = `phone number has already been registered`;
                    this.$refs["phoneLoader"].style = "visibility:hidden";
                    this.phoneInUse = true;
                    this.$nextTick(() => this.phoneEnabled);
                    this.$nextTick(() => this.$refs["phone"].focus());
                    } else {

                    this.$refs["phoneLoader"].innerText = "Phone number is not signed up";
                    }
                }
            } else
            ///////////////////////////////////////
            if(event.target.id === "phoneVerify"){
                if(event.target.checked){
                        this.checkNumber = true;
                        this.verifyPhone;
                    this.$nextTick(()=>this.$refs["phoneShortCode"].focus());
                    //call sms validator
                    let media = {
                        type: 'phone',
                        number: this.$refs["phone"].value
                    }
                    // let self = this;
                    this.$refs["shortCodeLoader"].style = "visibility:visible; display:block;";
                    let shortcode = await axios.post(`${HOST}/confirmDetails`, {media});
                    console.log(shortcode.data);
                    if(shortcode.data !== undefined){
                        this.$refs["shortCodeLoader"].innerText = "ShortCode Sent";
                        this.tempID = shortcode.data.messageID;
                        this.$nextTick(()=>this.$refs["phoneShortCode"].focus());
                    }
                }
            } else
            ///////////////////////////////////////
            if(event.target.id === "phoneShortCode"){
                let test = event.target.value.slice(0,3);
                console.log(test);
                if(test === "DW-"){
                    return event.target.value
                } else {

                event.target.value = "DW-"+event.target.value;
                }
            } else
            ////////////////////////////////////////
            if(event.target.id === "password2"){
                if(this.$refs["password"].value === this.$refs["password2"].value){
                    this.$refs["credValidate"].innerText = "Good to Go!";
                    this.$refs["credValidate"].style = "color:green";
                    this.cred = this.$refs["password"].value;
                } else {
                    this.$refs["credValidate"].innerText = "Passwords don't match";
                    this.$refs["credValidate"].style = "color:red";
                }
            } else
            /////////////////////////////////////////
            if(event.target.id === "privy"){
                if(event.target.checked){
                    this.submitReady = true;
                    this.okToSubmit;
                    this.$nextTick(() =>this.$refs["submitBtn"].focus());
                    this.privacyAcknowledged = true;
                } else {
                    this.submitReady = false;
                    this.okToSubmit;
                }
            }
        }

    }
}
</script>

<style scoped>

.input-text {
    border: solid 1px darkgrey;
    height: 20px;
    width: 150px;
    margin: 5px;
    padding: 2px;
}
.alert-message-initial {
    visibility: hidden;
}
.emailLoader{
    display: none;
    visibility: hidden;
    color: green;
}
.phoneLoader{
    display: none;
    visibility: hidden;
    color:green;
}
.shortCodeLoader {
    display: none;
    visibility: hidden;
    color:green;
}
.submitLoader {
    display: none;
    visibility: hidden;
    color:green;
}

 @keyframes blink {50% { color: transparent }}
.loader__dot { animation: 1s blink infinite }
.loader__dot:nth-child(2) { animation-delay: 250ms }
.loader__dot:nth-child(3) { animation-delay: 500ms }
</style>